import React from "react";
import { ThemeProvider as MaterialProvider } from "@material-ui/core/styles";
import JBTheme from "jb_component_library/theme/JBTheme";
import GroupTheme from "./GroupTheme";

const ThemeMap = {
	group: GroupTheme,
	jbhifi: JBTheme,
} as const;

export const ThemeProvider: React.FC<{
	theme?: keyof typeof ThemeMap;
}> = ({ children, theme = "group" }) => {
	return <MaterialProvider theme={GroupTheme}>{children}</MaterialProvider>;
};

export default ThemeProvider;